import React, { FC, forwardRef } from 'react';
import { Color } from 'components/colors';
import styles from './progress-pie.module.css';

const pixels = {
  small: 14,
  default: 18,
  large: 26,
};

/**
 * Color to be used for the progress status (pie), to denote the status.
 */
const ProgressColor = {
  default: styles.progress_color,
  success: styles.progress_color__success,
  warn: styles.progress_color__warn,
  error: styles.progress_color__danger,
  inProgress: styles.progress_color__progress,
  disabled: styles.progress_color__disabled,
  special: styles.progress_color__special,
};

/**
 * Color to be filled in the progress background, to denote the status.
 * NOTE :: This overrides inner progress bar section
 */
const FillColor = {
  default: styles.fill_color,
  success: styles.fill_color__success,
  warn: styles.fill_color__warn,
  error: styles.fill_color__danger,
  inProgress: styles.fill_color__progress,
  disabled: styles.fill_color__disabled,
  special: styles.fill_color__special,
};

type ProgressPieProps = {
  className?: string;
  progress?: number;
  size?: keyof typeof pixels;
  type?: 'default' | 'success' | 'warn' | 'error' | 'disabled';
  backgroundFill?: boolean;
  color?: Color;
};

export const ProgressPieMilestone: FC<ProgressPieProps> = forwardRef<
  any,
  ProgressPieProps
>(({ type = 'default', backgroundFill, color }) => {
  const stroke = color
    ? `var(--ozone-${color}-background)`
    : ProgressColor[type];
  const fillColor = color ? `var(--ozone-${color}-surface)` : FillColor[type];

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      style={{
        borderColor: stroke,
      }}
    >
      <g>
        <path
          d="M1.54044 9.87377L9.87377 1.54044C9.94348 1.47073 10.0565 1.47073 10.1262 1.54044L18.4596 9.87377C18.5293 9.94349 18.5293 10.0565 18.4596 10.1262L10.1262 18.4596C10.0565 18.5293 9.94348 18.5293 9.87377 18.4596L1.54044 10.1262C1.47073 10.0565 1.47073 9.94349 1.54044 9.87377Z"
          fill={backgroundFill ? fillColor : 'transparent'}
          stroke={stroke}
          strokeWidth="2"
        />
        {backgroundFill && (
          <path d="M15.625 10L10 4.375V10H15.625Z" fill={stroke} />
        )}{' '}
      </g>
    </svg>
  );
});
